import { api } from './client';

export interface AiQuoteResult {
  quoteItemId: number;
  vendor: string;
  unitPrice: number;
  deliveryDays: number | null;
  rating: number | null;
  ontimePct: number | null;
  aiScore: number;
  isBest: boolean;
  isAlternative: boolean;
  vsTarget: number | null; // % above(+) or below(-) target price
}

export interface AiItemResult {
  rfqItemId: number;
  itemName: string;
  targetPrice: number | null;
  bestQuoteItemId: number | null;
  alternativeQuoteItemId: number | null;
  savingsVsHighest: number;
  vsTarget: number | null;
  recommendation: string;
  results: AiQuoteResult[];
}

export interface AiScoreResult {
  rfqId: number;
  itemCount: number;
  totalSavings: number;
  aiPowered: boolean;
  model: string;
  advisorNotes: string[];
  results: AiItemResult[];
}

export async function scoreRfq(rfqId: number): Promise<AiScoreResult> {
  const r = await api.get<AiScoreResult>(`/ai/rfq/${rfqId}/score`);
  return r.data;
}

export async function rescoreRfq(rfqId: number): Promise<AiScoreResult> {
  const r = await api.post<AiScoreResult>(`/ai/rfq/${rfqId}/score`);
  return r.data;
}
